import ChallengeAwardedPlace from 'models/challenge/awardedPlace/ChallengeAwardedPlace';

/**
 * Class representing a challenge user container awarded place.
 * @extends ChallengeAwardedPlace
 */
export default class ChallengeUserContainerAwardedPlace extends ChallengeAwardedPlace {}
